import { ContextBuilder } from 'context/nutriscoreLabelContext';

import NutriScoreLabelManagementComponent from 'components/desktop/StandingData/NutriScoreLabel/Management/NutriScoreLabelManagementComponent';

const NutriScoreLabelManagementContainer = () => {
	return (
		<main className="container">
			<NutriScoreLabelManagementComponent />
		</main>
	);
};

export default ContextBuilder.From(NutriScoreLabelManagementContainer)
	.wrapWithNutriscoreContext()
	.build();
